module.exports = __webpack_public_path__ + "static/media/物流.4c80a290.jpg";